export class PaypalOptions {
    tenant_name: string;
    tenant_id: string;
    paypal_enabled: boolean;
    flag_editable: boolean;
  } 